// extracted by mini-css-extract-plugin
export default {"container":"StarsForm_container__vAYpG","starsContainer":"StarsForm_starsContainer__ykJBw","starWrapper":"StarsForm_starWrapper__Imelb","rating":"StarsForm_rating__T4THh"};